<template>
  <div class="page-audio" v-if="audioSrc != ''">
    <!-- 此处的ref属性，可以很方便的在vue组件中通过 this.$refs.audio获取该dom元素 -->
    <audio
      ref="audio" 
      @pause="onPause"
      @play="onPlay"
      @timeupdate="onTimeupdate"
      @loadedmetadata="onLoadedmetadata"
      :src="audioSrc"
    >
    </audio>

    <!-- 音频播放控件 -->
    <div class="audio-control">
      <el-button class="a-item" type="text" @click="startPlayOrPause">
        <i class="el-icon-video-play play-icon" v-if="!audio.playing"></i>
        <i class="el-icon-video-pause play-icon" v-else></i>
      </el-button>
      <el-button class="a-item time" type="text">{{ audio.currentTime | formatSecond}}</el-button>
      <el-slider
        class="a-item a-slider"
        v-model="audio.sliderTime"
        :format-tooltip="formatProcessToolTip"
        @mousedown.native="pause"
        @change="changeCurrentTime"
      >
      </el-slider>
      <el-button class="a-item time" type="text">{{ audio.maxTime | formatSecond}}</el-button>
    </div>
  </div>
</template>

<script>

// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
  var secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)

    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60

    return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

export default {
  props: {
    audioSrc: {
      type: String
    }
  },
  watch: {
    'audio.currentTime' (val) {
      if(val >= this.audio.maxTime){
        this.$emit('change', false)
      }
    }
  },
  data () {
    return {
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
        // 滑动条的进度
        sliderTime: 0
      }
    }
  },
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause () {
      this.$emit('change', !this.audio.playing)
      return this.audio.playing ? this.pause() : this.play()
    },
    // 播放音频
    play () {
      this.$refs.audio.play()
    },
    // 暂停音频
    pause () {
      this.$refs.audio.pause()
    },
    // 当音频播放
    onPlay () {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause () {
      this.audio.playing = false
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      // console.log('timeupdate')
      // console.log(res)
      this.audio.currentTime = res.target.currentTime
      this.audio.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      // console.log('loadedmetadata')
      // console.log(res)
      this.audio.maxTime = parseInt(res.target.duration)
    },
    // 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(index / 100 * this.audio.maxTime)
      this.play()
      this.$emit('change', !this.audio.playing)
    },
    // 进度条格式化toolTip
    formatProcessToolTip(index = 0) {
      index = parseInt(this.audio.maxTime / 100 * index)
      // return '进度条: ' + realFormatSecond(index)
      return realFormatSecond(index)
    },
  },
  filters: {
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second)
    }
  }
}
</script>

<style lang="less" scoped>
.page-audio{
  .audio-control{
    display: flex;
    align-items: center;
    height: 40px;
    .a-item{
      margin: 0 5px
    }
    .a-slider{
      flex: 1;
      margin: 0 10px;
    }
    .play-icon{
      font-size: 30px;
    }
    .time{
      cursor: auto;
    }
  }
}
/deep/.el-slider__button-wrapper{
  outline: none;
}
</style>